// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search__no-result{padding:4px 16px 12px;color:#000}`, "",{"version":3,"sources":["webpack://./src/components/atom/NoResultText/NoResultText.scss"],"names":[],"mappings":"AACI,mBACI,qBAAA,CACA,UAAA","sourcesContent":[".search {\n    &__no-result {\n        padding: 4px 16px 12px;\n        color: #000;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
